export type EmbedAssignmentGroup = AssignmentGroup;

export class AssignmentGroup {
    id: string;
    name: string;
    cells: string[];
    source: string;

    public static toCustomAssignmentGroup(data: AssignmentGroup): EmbedAssignmentGroup {
        return {
            id: data.id,
            name: data.name,
            cells: data.cells,
            source: data.source,
        };
    }

    public static toCustomAssignmentGroupList(data: AssignmentGroup[]): EmbedAssignmentGroup[] {
        return data.map((assignmentGroup) => this.toCustomAssignmentGroup(assignmentGroup));
    }
}
